import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Decimal } from 'decimal.js';
import { capitalize } from 'lodash-es';
import { serviceBillingModel, serviceCostModel } from '~/models';
import { RecurrencePeriodTypes } from '~/models/service-billing/model';
import { utils } from '~/utils';
export const makeSectionsFromServices = (services, options)=>{
    const onApproval = {
        id: 'onApproval',
        services: [],
        subtitle: options.isEffectiveDateInFuture ? 'Once, on effective date' : 'Once, on proposal acceptance',
        category: 'oneTime'
    };
    const onDemand = {
        id: 'onDemand',
        services: [],
        subtitle: 'On demand',
        category: 'oneTime'
    };
    const oneTimeManual = {
        id: 'oneTimeManual',
        services: [],
        subtitle: 'Once, on completion',
        category: 'oneTime'
    };
    const oneTimeInStages = {
        id: 'oneTimeInStages',
        services: [],
        subtitle: 'Billed in stages',
        category: 'oneTime'
    };
    const weekly = {
        id: 'weekly',
        services: [],
        subtitle: 'Every week',
        category: 'recurring'
    };
    const biWeekly = {
        id: 'biWeekly',
        services: [],
        subtitle: 'Every two weeks',
        category: 'recurring'
    };
    const monthly = {
        id: 'monthly',
        services: [],
        subtitle: 'Every month',
        category: 'recurring'
    };
    const quarterly = {
        id: 'quarterly',
        services: [],
        subtitle: 'Every quarter',
        category: 'recurring'
    };
    const yearly = {
        id: 'yearly',
        services: [],
        subtitle: 'Every year',
        category: 'recurring'
    };
    const variable = {
        id: 'variable',
        services: [],
        category: 'variable'
    };
    const optional = {
        id: 'optional',
        services: [],
        category: 'optional'
    };
    services.forEach((service)=>{
        const { name, id, description, cost, billing } = service;
        const isOptional = service.participation.type === 'optional';
        const includedByDefault = isOptional && service.participation.type === 'optional' ? service.participation.optional.includedByDefault : undefined;
        const baseServiceData = {
            name,
            id,
            description,
            includedServices: service.bundle ? service.bundle.services.map((param)=>{
                let { name, description } = param;
                return {
                    name,
                    description
                };
            }) : null,
            includedByDefault
        };
        const pushServiceToSection = (section, s)=>{
            const actualSection = isOptional ? optional : section;
            actualSection.services.push(s);
            if (isOptional) {
                section.hasOptionalServices = true;
            } else if (section.category !== 'variable') {
                const finalPrice = utils.applyDiscount(cost.price, cost.discount);
                actualSection.sum = new Decimal(actualSection.sum || 0).add(finalPrice);
            }
        };
        if (serviceCostModel.isVariablePrice(cost)) {
            const formattedCost = utils.formatNumberWithCommas(utils.applyDiscount(cost.price, cost.discount));
            const unit = capitalize(serviceCostModel.formattedUnitName(cost));
            const variablePriceText = "$".concat(formattedCost, "/").concat(unit);
            const s = isOptional ? baseServiceData : _object_spread_props(_object_spread({}, baseServiceData), {
                variablePriceText
            });
            pushServiceToSection(variable, s);
        } else if (serviceCostModel.isRangePrice(cost)) {
            const min = cost.minPrice ? utils.formatNumberWithCommas(utils.applyDiscount(cost.minPrice, cost.discount)) : null;
            const max = utils.formatNumberWithCommas(utils.applyDiscount(cost.maxPrice, cost.discount));
            const variablePriceText = min ? "$".concat(min, "—$").concat(max) : "Up to $".concat(max);
            const s = isOptional ? baseServiceData : _object_spread_props(_object_spread({}, baseServiceData), {
                variablePriceText
            });
            pushServiceToSection(variable, s);
        } else {
            const visitRecurring = (billing)=>{
                switch(billing.recurrencePeriod){
                    case RecurrencePeriodTypes.Weekly:
                        return weekly;
                    case RecurrencePeriodTypes.BiWeekly:
                        return biWeekly;
                    case RecurrencePeriodTypes.Monthly:
                        return monthly;
                    case RecurrencePeriodTypes.Quarterly:
                        return quarterly;
                    case RecurrencePeriodTypes.Yearly:
                        return yearly;
                }
            };
            const section = serviceBillingModel.accept(billing, {
                visitOnApproval: ()=>onApproval,
                visitOneTimeManual: ()=>oneTimeManual,
                visitOneTimeInStages: ()=>oneTimeInStages,
                visitOngoing: visitRecurring,
                visitRepeatableManual: visitRecurring,
                visitOnDemand: ()=>onDemand
            });
            pushServiceToSection(section, baseServiceData);
        }
    });
    return [
        onApproval,
        onDemand,
        oneTimeManual,
        oneTimeInStages,
        weekly,
        biWeekly,
        monthly,
        quarterly,
        yearly,
        variable,
        optional
    ].filter((param)=>{
        let { services } = param;
        return services.length > 0;
    });
};
